import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'GESTION_INVIT',
  title: 'Come gestire l\'accesso alla mia cartella?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Dalla scheda «Parametri» della vostra azienda, potete scegliere di gestire automaticamente o manualmente la messa a disposizione dei vostri documenti ai vostri clienti.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Selezionare o deselezionare il pulsante e quindi convalidare.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_GESTION_INVIT/IT_GESTION_INVIT.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Se scegliete di gestire manualmente la messa a disposizione dei vostri documenti, i vostri clienti non potranno accedere immediatamente alla vostra cartella. Dovrete quindi convalidare ogni invito.'
  }]
};
